import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import RichText from 'core/components/RichText';
import { JssTextType, isJssField } from 'core/utils/sitecore-utils';

interface IProps {
	config: {
		data: {
			content: string | JssTextType;
		};
	};
}

const FormRichtext = ({ config }: IProps) => {
	return isJssField(config.data.content) ? (
		<Text field={config.data.content as JssTextType} />
	) : (
		<RichText content={config.data.content as string} />
	);
};

export default FormRichtext;
